import UsageBlock from '@components/usageblock';
import ComponentItem from '@components/componentitem';
import pAccess from '@images/principles/Accessibility.png';
import pCognitive from '@images/principles/Cognitive.png';
import pContent from '@images/principles/Content.png';
import pInformation from '@images/principles/Information.png';
import pLanguage from '@images/principles/Language.png';
import pVisual from '@images/principles/Visual.png';
import landingIcon from '@images/navigation/principlespage.png';
import * as React from 'react';
export default {
  UsageBlock,
  ComponentItem,
  pAccess,
  pCognitive,
  pContent,
  pInformation,
  pLanguage,
  pVisual,
  landingIcon,
  React
};